import { FULL_GLOBAL_SEARCH, GLOBAL_CATALOGS, HAS_DETAILS } from '../types';
import { queryContentList } from './cmsAction';

export const updateSearchValue = (value) => async (dispatch, getState) => {  
  await dispatch({
    type: FULL_GLOBAL_SEARCH.Value,
    payload: value
  });
};

// 關鍵字搜索
export const updateSearchKey = (value) => async (dispatch, getState) => {
  const { search: { page, rowsPerPage } } = getState();
  await dispatch({
    type: FULL_GLOBAL_SEARCH.Keyword,
    payload: value
  });
  await dispatch(updateSearchValue(value));
  await dispatch(queryGlobalSearchList({ title: value,  page, rowsPerPage }));
};


export const queryGlobalSearchList = ({ contentCode = GLOBAL_CATALOGS.FullTextSearch, title = '', ruleTag, page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  
  await dispatch({
    type: FULL_GLOBAL_SEARCH.Loading,
    payload: true
  });

  const response = await dispatch(queryContentList({ contentCode, hasDetails: HAS_DETAILS.True, ruleTag, title, page, rowsPerPage }));
  
  await dispatch({
    type: GLOBAL_CATALOGS.FullTextSearch,
    payload: response
  });


  setTimeout(() => {
    dispatch({
      type: FULL_GLOBAL_SEARCH.Loading,
      payload: false
    });
  }, 260);
};




